import request from "@/utils/request";

export function germinationBatchTransasctionGet(params) {
    return request({
        url: "/api/services/app/GerminationBatchTransaction/Get",
        method: "get",
        params
    });
}

export function germinationBatchTransasctionGetAll(params) {
    return request({
        url: "/api/services/app/GerminationBatchTransaction/GetAll",
        method: "get",
        params
    });
}

export function germinationBatchTransasctionCreate(data) {
    return request({
        url: "/api/services/app/GerminationBatchTransaction/Create",
        method: "post",
        data
    });
}

export function germinationBatchTransasctionUpdate(data) {
    return request({
        url: "/api/services/app/GerminationBatchTransaction/Update",
        method: "put",
        data
    });
}

export function germinationBatchTransasctionDelete(params) {
    return request({
        url: "/api/services/app/GerminationBatchTransaction/Delete",
        method: "delete",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/germination_batch_transaction.js